import { readFormField } from './dom-helpers';
import { materialIdAttr } from './materials';
import { getAssignments } from './assign_user';
import { startCreateProgress } from './create-progress';

export function getSpecialAdCountries() {
  const $form = $('#ad-campaign-info-step form.campaign-form');
  const geoLocations = $form
    .find('[data-role="campaign-geo-location"] input[type="checkbox"]:checked')
    .map((_i, el) => (el as HTMLInputElement).value)
    .get();

  return geoLocations
}

export function getGeoLocations() {
  const $form = $('#ad-campaign-info-step form.campaign-form');
  const adsetGeoLocations = $form
  .find('[data-role="campaign-adset-geo-location"] input[type="checkbox"]:checked')
  .map((_i, el) => (el as HTMLInputElement).value)
  .get();

  return adsetGeoLocations;
}

export function submitCreateCampaign($btn: JQuery): void {
  const $body = $('#ad-campaign-modal-body');
  const audienceId = $body.attr('data-audience-id');
  const squareId = $body.attr(materialIdAttr('square'));
  const storyId = $body.attr(materialIdAttr('story'));
  const $form = $('#ad-campaign-info-step form.campaign-form');

  if (!audienceId || !squareId || !storyId) {
    window.alert('Missing audience or material selection.');
    return;
  }

  const countriesList = getSpecialAdCountries();

  if (countriesList.length === 0) {
    window.alert('Select at least one special ad country.');
    return;
  }

  const adsetGeoLocations = getGeoLocations();

  if (adsetGeoLocations.length === 0) {
    window.alert('Select at least one ad set geographic location.');
    return;
  }

  const payload = {
    audience_id: audienceId,
    square_material_id: squareId,
    story_material_id: storyId,
    geo_locations: countriesList,
    adset_geo_locations: adsetGeoLocations,
    name: readFormField($form, 'name'),
    primary_text: readFormField($form, 'primary_text'),
    headline: readFormField($form, 'headline'),
    description: readFormField($form, 'description'),
    link_to_page: readFormField($form, 'link_to_page'),
    objective: readFormField($form, 'objective'),
    budget_type: readFormField($form, 'budget_type'),
    budget_amount: readFormField($form, 'budget_amount'),
    start_date: readFormField($form, 'start_date'),
    end_date: readFormField($form, 'end_date'),
    special_ad_categories: readFormField($form, 'special_ad_categories'),
    assignments: getAssignments().map(entry => ({
      user_id: entry.user?.id ?? null,
      user_company_id: entry.company?.id ?? null,
    })),
  };

  const originalHtml = $btn.html();
  const $editButtons = $('#ad-review-step [data-edit-step]');
  $btn.prop('disabled', true).html(
    '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> &nbsp; Creating...'
  );
  $('#back-btn').prop('disabled', true);
  $editButtons.prop('disabled', true);

  const restoreButtons = (): void => {
    $btn.prop('disabled', false).html(originalHtml);
    $('#back-btn').prop('disabled', false);
    $editButtons.prop('disabled', false);
  };

  $.ajax({
    url: '/meta_apis/ad_campaigns/wizard_create',
    method: 'POST',
    contentType: 'application/json',
    headers: { 'X-CSRF-Token': document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? '' },
    data: JSON.stringify(payload),
    success: function(response: { success: boolean; ad_campaign_id?: string; error?: string; status?: string }) {
      if (!response.success || !response.ad_campaign_id) {
        window.alert(response.error ?? 'Failed to create campaign.');
        restoreButtons();
        return;
      }

      const adCampaignId = response.ad_campaign_id;
      $btn.html('<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> &nbsp; Processing on Meta...');

      window.setTimeout(() => {
        restoreButtons();
        $('#campaignModal').modal('hide');
        startCreateProgress(adCampaignId);
      }, 3000);
    },
    error: function(xhr) {
      const err = xhr.responseJSON?.error ?? 'Failed to create campaign.';
      window.alert(err);
      restoreButtons();
    },
  });
}
